module.exports = __webpack_public_path__ + "static/media/nile shot 4.4fa2c38c.webp";